import axios from "axios";
import { myHistory } from "./history";

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 403 || error.response.status === 401) {
      const loginPath = "/login";
      if (window.location.pathname !== loginPath) {
        myHistory.push(loginPath, { from: window.location.href });
      }
    }
  }
);
